import platform from '@/shared/utils/platform';

// 奖励金场景英文名
export const rewardingSceneNameEn = 'finance';
// 奖励金子场景英文名
export const rewardingSubSceneNameEnH5 = 'finance_h5';
export const rewardingSubSceneNameEnApp = 'finance_app';
export const rewardingSubSceneNameEn = platform.isHelloApp
  ? rewardingSubSceneNameEnApp
  : rewardingSubSceneNameEnH5;

// 奖励金活动状态
export const rewardingStatuses = {
  // 未开始
  init: 'INIT',
  // 进行中
  running: 'RUNNING',
  // 已结束
  finished: 'FINISHED',
  // 过期未完成
  unfinished: 'UNFINISHED',
  // 强制终止
  forceStop: 'FORCE_STOP',
};

// 获取奖励金任务列表的请求参数类型
export interface GetRewardingTaskListParams {
  // 任务状态 INIT：未开始，RUNNING：进行中，FINISHED：已结束, UNFINISHED: 过期未完成, FORCE_STOP: 强制终止
  taskStatusList: string[];
  // 页码
  pageIndex?: number;
  // 每页记录数
  pageSize?: number;
}

// 奖励金任务数据类型
export interface RewardingTaskType {
  // 任务组code
  taskGroupCode?: string;
  // 任务编号
  taskCode?: string;
  // 任务执行实例的唯一编码。比如周期任务，不同周期，taskGuid不一样
  taskGuid?: string;
  // 任务名称
  taskName?: string;
  // AB测试实验id
  expertId?: string;
  // 命中的用户标签
  userTags?: {
    // 标签中文名
    name?: string;
    // 标签值
    value?: string;
  }[];
  // 引导文案
  guideDesc?: string;
  // 引导文案的奖励名称
  guideAwardDesc?: string;
  // 按钮名称
  btnName?: string;
  // 按钮链接
  btnLink?: {
    // app链接
    app?: string;
    // 支付包小程序链接
    ali?: string;
  };
  // 任务状态 INIT：未开始，RUNNING：进行中，FINISHED：已结束, UNFINISHED: 过期未完成,
  taskStatus?: string;
  // 任务上所有权益的总价值
  offerWorth?: number;
  // 任务总进度
  totalProgress?: number;
  // 任务当前进度
  currentProgress?: number;
  progressUnit?: string;
  // 任务开始时间 "yyyy-MM-dd HH:mm:ss"
  startDate?: string;
  // 任务失效时间 "yyyy-MM-dd HH:mm:ss"
  expireDate?: string;
  // 权益的失效时间。超过该时间后，奖励不能再被领取
  offerExpireDate?: string;
  // 任务派发方式 1: 任务需要用户手动领取 2: 任务自动派发
  taskSendType?: number;
}

export interface RewardingTasksInfo {
  taskList: RewardingTaskType[];
  // 子场景英文名
  subSceneNameEn: string;
  // 场景英文名
  sceneNameEn: string;
  // 标题栏文案
  displayTitle?: string;
  // 标题栏规则文案
  displayRule?: string;
  // 标题栏规则链接
  displayRuleLink?: string;
  // 查看更多任务链接
  showMoreTaskLink?: string;
  // 任务完成，提示领奖文案
  hitPrizeDesc?: string;
  // 奖励领取，提示即将到账文案
  sendPrizeDesc?: string;
  // 领奖被风控文案
  riskPrizeDesc?: string;
}

// 任务类型
export interface TaskType {
  // 任务组code
  taskGroupCode?: string;
  // 任务code
  taskCode?: string;
  // 用户进度状态
  taskStatus?: string;
  // 任务总进度
  totalProgress?: number;
  // 当前任务进度
  currentProgress?: number;
  // 按钮名称
  btnName?: string;
  // 任务开始时间
  startDate?: string;
  // 任务失效时间
  expireDate?: string;
  // 错误码。0表示领取任务成功
  errorCode?: number;
  // 错误信息
  errMsg?: string;
}

// 批量领取任务接口传参类型
export interface AcceptTaskListParamsType {
  // 任务列表
  taskList: {
    // 任务组code
    taskGroupCode: string;
    // 任务code
    taskCode: string;
    // 用户命中的标签列表
    userTags?: {
      // 标签中文名
      name?: string;
      // 标签值
      value?: string;
    }[];
    // AB测试实验id。从展示任务列表的接口里获取
    expertId?: string;
  }[];
}

// 手动领取奖励金奖励接口传参类型
export interface ReceiveAwardParamsType {
  // 任务组code。平台奖励金任务必传
  taskGroupCode?: string;
  // 任务guid
  taskGuid: string;
  // 阶梯奖励的领奖节点。阶梯奖励任务必传该字段！
  stageNo?: number;
}

// 现金活动详情接口返回类型
export interface CashActivityDetailResType {
  // 是否匹配
  match: boolean;
  // 标题提醒文案
  remind?: string;
}
